import { api_GET, api_POST, api_PUT } from "./_api";

const tipoDestino_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`tipoDestino/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`tipoDestino/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`tipoDestino`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`tipoDestino`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default tipoDestino_api;